module.exports = __webpack_public_path__ + "static/media/24-WaterHeatExchanger - No cool - Water heat.2bd4f218.png";